let bigObj = {
    user1: {
        signedIn: false,
        moved: 0,
        white: true,
        canMove: false,
        // piecesMoved: [], //could be 3
        // casualty: null,//name
        // pawnReincarnate: null,//name
        quit: false,
        rematch: false,
        pawnPromotionNumber: 3,
        movedFrom: '',
        movedTo: '',
        pieces: {
            "pawn1": {
                white: true,
                rowPosition: '7/8',
                columnPosition: '1/2',
                alive: true,
                name: "pawn1",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn2": {
                white: true,
                rowPosition: '7/8',
                columnPosition: '2/3',
                alive: true,
                name: "pawn2",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn3": {
                white: true,
                rowPosition: '7/8',
                columnPosition: '3/4',
                alive: true,
                name: "pawn3",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn4": {
                white: true,
                rowPosition: '7/8',
                columnPosition: '4/5',
                alive: true,
                name: "pawn4",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn5": {
                white: true,
                rowPosition: '7/8',
                columnPosition: '5/6',
                alive: true,
                name: "pawn5",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn6": {
                white: true,
                rowPosition: '7/8',
                columnPosition: '6/7',
                alive: true,
                name: "pawn6",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn7": {
                white: true,
                rowPosition: '7/8',
                columnPosition: '7/8',
                alive: true,
                name: "pawn7",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn8": {
                white: true,
                rowPosition: '7/8',
                columnPosition: '8/9',
                alive: true,
                name: "pawn8",
                moved: 0,
                justMoved2Squares: false,
            },
            "rook1": {
                white: true,
                rowPosition: '8/9',
                columnPosition: '1/2',
                alive: true,
                moved: false,
                name: "rook1",
            },
            "rook2": {
                white: true,
                rowPosition: '8/9',
                columnPosition: '8/9',
                alive: true,
                moved: false,
                name: "rook2",
            },
            "knight1": {
                white: true,
                rowPosition: '8/9',
                columnPosition: '2/3',
                alive: true,
                name: "knight1",
            },
            "knight2": {
                white: true,
                rowPosition: '8/9',
                columnPosition: '7/8',
                alive: true,
                name: "knight2",
            },
            "bishop1": {
                white: true,
                rowPosition: '8/9',
                columnPosition: '3/4',
                alive: true,
                name: "bishop1",
            },
            "bishop2": {
                white: true,
                rowPosition: '8/9',
                columnPosition: '6/7',
                alive: true,
                name: "bishop2",
            },
            "king": {
                white: true,
                rowPosition: '8/9',
                columnPosition: '5/6',
                alive: true,
                moved: false,
                name: "king",
            },
            "queen": {
                white: true,
                rowPosition: '8/9',
                columnPosition: '4/5',
                alive: true,
                name: "queen",
            },
        },
    },
    user2: {
        signedIn: false,
        moved: 0,
        white: false,
        canMove: false,
        // piecesMoved: [], //could be 3
        // casualty: null,//name
        // pawnReincarnate: null,//name
        quit: false,
        rematch: false,
        recentlyReset: false,
        pawnPromotionNumber: 3,
        movedFrom: '',
        movedTo: '',
        pieces: {
            "pawn1": {
                white: false,
                rowPosition: '2/3',
                columnPosition: '8/9',
                alive: true,
                name: "pawn1",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn2": {
                white: false,
                rowPosition: '2/3',
                columnPosition: '7/8',
                alive: true,
                name: "pawn2",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn3": {
                white: false,
                rowPosition: '2/3',
                columnPosition: '6/7',
                alive: true,
                name: "pawn3",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn4": {
                white: false,
                rowPosition: '2/3',
                columnPosition: '5/6',
                alive: true,
                name: "pawn4",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn5": {
                white: false,
                rowPosition: '2/3',
                columnPosition: '4/5',
                alive: true,
                name: "pawn5",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn6": {
                white: false,
                rowPosition: '2/3',
                columnPosition: '3/4',
                alive: true,
                name: "pawn6",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn7": {
                white: false,
                rowPosition: '2/3',
                columnPosition: '2/3',
                alive: true,
                name: "pawn7",
                moved: 0,
                justMoved2Squares: false,
            },
            "pawn8": {
                white: false,
                rowPosition: '2/3',
                columnPosition: '1/2',
                alive: true,
                name: "pawn8",
                moved: 0,
                justMoved2Squares: false,
            },
            "rook1": {
                white: false,
                rowPosition: '1/2',
                columnPosition: '8/9',
                alive: true,
                moved: false,
                name: "rook1",
            },
            "rook2": {
                white: false,
                rowPosition: '1/2',
                columnPosition: '1/2',
                alive: true,
                moved: false,
                name: "rook2",
            },
            "knight1": {
                white: false,
                rowPosition: '1/2',
                columnPosition: '7/8',
                alive: true,
                name: "knight1",
            },
            "knight2": {
                white: false,
                rowPosition: '1/2',
                columnPosition: '2/3',
                alive: true,
                name: "knight2",
            },
            "bishop1": {
                white: false,
                rowPosition: '1/2',
                columnPosition: '6/7',
                alive: true,
                name: "bishop1",
            },
            "bishop2": {
                white: false,
                rowPosition: '1/2',
                columnPosition: '3/4',
                alive: true,
                name: "bishop2",
            },
            "king": {
                white: false,
                rowPosition: '1/2',
                columnPosition: '5/6',
                alive: true,
                moved: false,
                name: "king",
            },
            "queen": {
                white: false,
                rowPosition: '1/2',
                columnPosition: '4/5',
                alive: true,
                name: "queen",
            },
        },
    },
    winner: '',
}

export default bigObj;